import createBrowserHistory from 'history/createBrowserHistory';

const history = createBrowserHistory({ forceRefresh: false });

export default history;
